import {exportPage} from './importExport'
import {pointerUtils, type DAL, type ExtensionAPI} from '@wix/document-manager-core'
import type {
    CompRef,
    DocumentExternalPageUpdate,
    DocumentExternalUpdate,
    FragmentsOptions,
    PageUpdateInfo
} from '@wix/document-services-types'
import {VIEW_MODES} from '../../../constants/constants'
import type {PageExtensionAPI} from '../../page'
import type {ImportExportExtensionApi} from '../../import-export/importExportExtension'
import type {FragmentsExtensionAPI} from '../../fragments/fragments'

const {getCompPointer} = pointerUtils

const buildDocumentPageInfo = (pagePointer: CompRef, extensionAPI: ExtensionAPI): PageUpdateInfo => {
    const {page} = extensionAPI as PageExtensionAPI

    return {
        title: page.getPageTitle(pagePointer.id) ?? pagePointer.id,
        type: 'Page'
    }
}

const buildDocumentPageUpdate = (
    pagePointer: CompRef,
    dal: DAL,
    extensionAPI: ExtensionAPI
): DocumentExternalPageUpdate => {
    const data = exportPage(pagePointer, extensionAPI, dal)
    if (!data) {
        return null
    }

    const info = buildDocumentPageInfo(pagePointer, extensionAPI)

    return {
        data,
        info
    }
}

const buildDocumentFragmentsUpdate = (fragmentTypes: string[], extensionAPI: ExtensionAPI) => {
    const {importExport} = extensionAPI as ImportExportExtensionApi
    const {fragmentIndex} = extensionAPI as FragmentsExtensionAPI

    const fragmentOptions: FragmentsOptions = fragmentIndex.getFragmentInstances(fragmentTypes)

    return importExport.fragments.export(fragmentOptions)
}

export const buildDocumentUpdate = (
    pageIds: string[],
    fragmentTypes: string[],
    dal: DAL,
    extensionAPI: ExtensionAPI
): DocumentExternalUpdate => {
    const documentUpdate: DocumentExternalUpdate = {pages: {}, fragments: {}}

    for (const pageId of pageIds) {
        const pagePointer = getCompPointer(pageId, VIEW_MODES.DESKTOP)
        documentUpdate.pages[pageId] = buildDocumentPageUpdate(pagePointer, dal, extensionAPI)
    }

    if (fragmentTypes.length) {
        documentUpdate.fragments = buildDocumentFragmentsUpdate(fragmentTypes, extensionAPI)
    }

    return documentUpdate
}
